module.exports = __webpack_public_path__ + "img/location-category-online.918f0a5.png";